// extracted by mini-css-extract-plugin
export default {"feed":"feed_feed__fH2Uw","feedWrapper":"feed_feedWrapper__eEf6M"};